import { Event } from '@rcp/types';
import { Resource, localizationService } from 'src/services';
import { RestSlice } from '../../../../../../redux/rest.slice';

export const facilityEventSlice = new RestSlice<Event>(
	localizationService.getLocalizedString('events.facilityEvents'),
	Resource.Events
);
export const FacilityEventReducer = facilityEventSlice.rests.reducer;
